import { Fragment, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import BasicCreatePassword from "./AuthenticationInner/CreatePassword/Basic"
import { doGetShortUrl, ShortUrl } from "../services/project.service"
import { toast, ToastContainer } from "react-toastify"
import Pages404 from "./AuthenticationInner/Pages404"
import InvoicePage from "./InvoicePage"

const ShortUrlPage = () => {
  const { code } = useParams<{ code: string }>();

  const [shortUrl, setShortUrl] = useState<ShortUrl>()
  const [invalid, setInvalid] = useState<boolean>(false)

  async function handleGetShortUrl(code: string) {
    const shortUrl = (await doGetShortUrl(code) as any) as ShortUrl
    if (!shortUrl) {
      toast.error("Link invalid or expired", { autoClose: 2000 })
      setInvalid(true)
      return
    }

    setShortUrl(shortUrl)
  }

  useEffect(() => {
    if (code) {
      handleGetShortUrl(code)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code])

  return (
    <Fragment>
      <ToastContainer closeButton={false} limit={1} />
      {invalid && <Pages404 />}
      {
        shortUrl?.type === "reset-password" &&
        <BasicCreatePassword userId={shortUrl.refId} shortUrlCode={shortUrl.code} />
      }
      {
        shortUrl?.type === "invoice" &&
        <InvoicePage projectId={shortUrl.projectId} shortUrl={shortUrl} />
      }
    </Fragment>
  )
}

export default ShortUrlPage